import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: "",
    summary: null,
    gradeSections: [],
    myGradesSections: [],
    students: [],
    studentsPagination: {},
    studentsLoading: false,
    insights: null,
    insightsLoading: false,
};

export const teacherDashboardSlice = createSlice({
    name: "teacherDashboard",
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setSummary(state, action) {
            state.summary = action.payload;
            state.loading = false;
        },
        setGradeSections(state, action) {
            state.gradeSections = action.payload || [];
        },
        setMyGradesSections(state, action) {
            state.myGradesSections = action.payload || [];
        },
        setStudentsLoading(state, action) {
            state.studentsLoading = action.payload;
        },
        setStudents(state, action) {
            const payload = action.payload || {};
            state.students = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : []);
            state.studentsPagination = payload.pagination || {};
            state.studentsLoading = false;
        },
        setInsightsLoading(state, action) {
            state.insightsLoading = action.payload;
        },
        setInsights(state, action) {
            state.insights = action.payload || null;
            state.insightsLoading = false;
        },
        setError(state, action) {
            state.error = action.payload;
            state.loading = false;
            state.studentsLoading = false;
            state.insightsLoading = false;
        },
    },
});

export const teacherDashboardActions = {
    loadSummary: createAction(`${teacherDashboardSlice.name}/loadSummary`, (payload) => ({ payload })),
    loadGradeSections: createAction(`${teacherDashboardSlice.name}/loadGradeSections`, (payload) => ({ payload })),
    loadMyGradesSections: createAction(`${teacherDashboardSlice.name}/loadMyGradesSections`, (payload) => ({ payload })),
    loadStudents: createAction(`${teacherDashboardSlice.name}/loadStudents`, (payload) => ({ payload })),
    loadInsights: createAction(`${teacherDashboardSlice.name}/loadInsights`, (payload) => ({ payload })),
    setSummary: teacherDashboardSlice.actions.setSummary,
    setGradeSections: teacherDashboardSlice.actions.setGradeSections,
    setMyGradesSections: teacherDashboardSlice.actions.setMyGradesSections,
    setStudents: teacherDashboardSlice.actions.setStudents,
    setInsights: teacherDashboardSlice.actions.setInsights,
    setLoading: teacherDashboardSlice.actions.setLoading,
    setStudentsLoading: teacherDashboardSlice.actions.setStudentsLoading,
    setInsightsLoading: teacherDashboardSlice.actions.setInsightsLoading,
    setError: teacherDashboardSlice.actions.setError,
};

export const getTeacherSummary = (state) => state.teacherDashboard.summary;
export const getTeacherGradeSections = (state) => state.teacherDashboard.gradeSections;
export const getTeacherMyGradesSections = (state) => state.teacherDashboard.myGradesSections;
export const getTeacherStudents = (state) => state.teacherDashboard.students;
export const getTeacherStudentsPagination = (state) => state.teacherDashboard.studentsPagination;
export const isTeacherDashboardLoading = (state) => state.teacherDashboard.loading;
export const isTeacherStudentsLoading = (state) => state.teacherDashboard.studentsLoading;
export const getTeacherInsights = (state) => state.teacherDashboard.insights;
export const isTeacherInsightsLoading = (state) => state.teacherDashboard.insightsLoading;

export default teacherDashboardSlice.reducer;
